export const tawk = {
  mountCount: 0,
  wantVisible: false,
  pendingMaximize: false,
  notifyClosed: null,
};

export function callTawk(method) {
  const api = typeof window !== 'undefined' ? window.Tawk_API : null;
  if (!api || typeof api[method] !== 'function') return;
  try {
    api[method]();
  } catch {
    // Widget may not be ready yet.
  }
}

export function syncVisibility() {
  if (tawk.mountCount > 0 && tawk.wantVisible) callTawk('showWidget');
  else callTawk('hideWidget');
}
